const permissions = {
    organizations: {
        FILTER_LIST_ORGANIZATION: "FILTER_LIST_ORGANIZATION",
        CREATE_ORGANIZATION_WITH_USER: "CREATE_ORGANIZATION_WITH_USER",
        CREATE_ORGANIZATION: "CREATE_ORGANIZATION",
        UPDATE_ORGANIZATION: "UPDATE_ORGANIZATION",
        VIEW_ORGANIZATION: "VIEW_ORGANIZATION",
        LIST_ORGANIZATION: "LIST_ORGANIZATION",
        // ORG_LIST_ACCOUNT: "ORG_LIST_ACCOUNT"
    },
    ports: {
        LIST_PORT: "LIST_PORT",
        CREATE_PORT: "CREATE_PORT",
        VIEW_PORT: "VIEW_PORT",
        CHANGE_UPDATE_PORT: "CHANGE_UPDATE_PORT",
        GET_PORT_TYPE_LIST: "GET_PORT_TYPE_LIST",
        CHANGE_STATUS_PORT: "CHANGE_STATUS_PORT",
        DELETE_PORT: "DELETE_PORT",
        FILTER_LIST_PORT: "FILTER_LIST_PORT"
    },
    gate: {
        LIST_GATE: "LIST_GATE",
        CREATE_GATE: "CREATE_GATE",
        CHANGE_STATUS_GATE: "CHANGE_STATUS_GATE",
        DELETE_GATE: "DELETE_GATE",
        VIEW_GATE: "VIEW_GATE",
        FILTER_LIST_GATE: "FILTER_LIST_GATE"
    },
    rbac: {
        ROLE_MANAGEMENT: "ROLE_MANAGEMENT",
        PERMISSION_MANAGEMENT: "PERMISSION_MANAGEMENT",
        ACCESS_MANAGEMENT: "ACCESS_MANAGEMENT",
        MODULE_MANAGEMENT: "MODULE_MANAGEMENT",
    },
    deviceManagement: {
        LIST_DEVICE: "LIST_DEVICE",
        REGISTER_DEVICE: "REGISTER_DEVICE",
        VIEW_DEVICE: "VIEW_DEVICE",
        UPDATE_STATUS_DEVICE: "UPDATE_STATUS_DEVICE",
        DELETE_DEVICE: "DELETE_DEVICE",
        UPDATE_DEVICE: "UPDATE_DEVICE",
        UPDATE_ENTRY_TYPE_DEVICE: "UPDATE_ENTRY_TYPE_DEVICE"
    },
    dashboard: {
        DASHBOARD_COUNT_USERS: "DASHBOARD_COUNT_USERS",
        DASHBOARD_COUNT_USERS_BY_ROLE: "DASHBOARD_COUNT_USERS_BY_ROLE",
        DASHBOARD_COUNT_GATEPASS: "DASHBOARD_COUNT_GATEPASS",
        DASHBOARD_COUNT_VEHICLE: "DASHBOARD_COUNT_VEHICLE",
        DASHBOARD_COUNT_BOOKING: "DASHBOARD_COUNT_BOOKING",
        DASHBOARD_COUNT_VEHICLE_ACCESSLOGS: "DASHBOARD_COUNT_VEHICLE_ACCESSLOGS",
        DASHBOARD_BOOKING_ASSIGNED: "DASHBOARD_BOOKING_ASSIGNED",

        DASHBOARD_BOOKING: "DASHBOARD_BOOKING",
        
        DASHBOARD_VEHICLE: "DASHBOARD_VEHICLE",

        DASHBOARD_ACCESSLOGS: "DASHBOARD_ACCESSLOGS",

        DASHBOARD_USERS: "DASHBOARD_USERS",

        DASHBOARD_GATEPASS: "DASHBOARD_GATEPASS",

        DASHBOARD_CONTAINER: "DASHBOARD_CONTAINER",

        DASHBOARD_PORT: "DASHBOARD_PORT",

        DASHBOARD_DEVICE: "DASHBOARD_DEVICE",

        DASHBOARD_BOOKING_COMPONENT: "DASHBOARD_BOOKING_COMPONENT",
        DASHBOARD_VEHICLE_COMPONENT: "DASHBOARD_VEHICLE_COMPONENT",
        DASHBOARD_CONTAINER_COMPONENT: "DASHBOARD_CONTAINER_COMPONENT",
        DASHBOARD_GATEPASS_COMPONENT: "DASHBOARD_GATEPASS_COMPONENT"
        
    },
    users: {
        LIST_ACCOUNT: "LIST_ACCOUNT",
        CREATE_ACCOUNT: "CREATE_ACCOUNT",
        VIEW_USER_PROFILE: "VIEW_USER_PROFILE",
        UPDATE_ACCOUNT: "UPDATE_ACCOUNT",
        FILTER_LIST_ACCOUNT: "FILTER_LIST_ACCOUNT"
    },
    containers: {
        LIST_CONTAINER: "LIST_CONTAINER",
        CREATE_CONTAINER: "CREATE_CONTAINER",
        VIEW_CONTAINER: "VIEW_CONTAINER",
        CHANGE_UPDATE_CONTAINER: "CHANGE_UPDATE_CONTAINER",
        CHANGE_STATUS_CONTAINER: "CHANGE_STATUS_CONTAINER",
        DELETE_CONTAINER: "DELETE_CONTAINER",
        FILTER_LIST_CONTAINER: "FILTER_LIST_CONTAINER",
        GET_CONTAINER_TYPE: "GET_CONTAINER_TYPE",
        LIST_SEARCH_CONTAINER: "LIST_SEARCH_CONTAINER",
    },
    gatepass: {
        GENERATE_GATEPASS: "GENERATE_GATEPASS",
        LIST_GATEPASS: "LIST_GATEPASS",
        VIEW_GATEPASS: "VIEW_GATEPASS",
        CHANGE_STATUS_GATEPASS: "CHANGE_STATUS_GATEPASS",
        UPDATE_GATEPASS: "UPDATE_GATEPASS",
        GENERATE_VEHICLE_GATEPASS: "GENERATE_VEHICLE_GATEPASS",
    },
    vehicle: {
        LIST_VEHICLE: "LIST_VEHICLE",
        VIEW_VEHICLE: "VIEW_VEHICLE",
        CHANGE_STATUS_VEHICLE: "CHANGE_STATUS_VEHICLE",
        CREATE_VEHICLE: "CREATE_VEHICLE",
        UPDATE_VEHICLE: "UPDATE_VEHICLE",
    },
    booking: {
        LIST_BOOKING: "LIST_BOOKING",
        CREATE_BOOKING: "CREATE_BOOKING",
        CHANGE_STATUS_BOOKING: "CHANGE_STATUS_BOOKING",
        VIEW_BOOKING: "VIEW_BOOKING",
        UPDATE_BOOKING: "UPDATE_BOOKING",
        DELETE_BOOKING: "DELETE_BOOKING",
    },

    drivers: {
        LIST_DRIVER: "LIST_DRIVER",
        CREATE_DRIVER: "CREATE_DRIVER",
        VIEW_DRIVER: "VIEW_DRIVER",
        LIST_DRIVER_ALL: "LIST_DRIVER_ALL",
        LIST_SEARCH_DRIVER_USER: "LIST_SEARCH_DRIVER_USER",
        FILTER_ORG_LIST_DRIVER: "FILTER_ORG_LIST_DRIVER",
        FILTER_LIST_DRIVER: "FILTER_LIST_DRIVER"
    }

}

const assignedPermissions = {
  PORT_EMPLOYEE: {...permissions},
  BUSINESS: {
    ...permissions.dashboard, 
    ...permissions.users, 
    ...permissions.containers, 
    ...permissions.gatepass, 
    ...permissions.vehicle, 
    ...permissions.booking,
    ...permissions.drivers,
  },
  INDIVIDUAL: {
    ...permissions.gatepass, 
    ...permissions.vehicle, 
    ...permissions.booking,
    ...permissions.drivers
  },
};

const exemptedAPIPrefixRoutes = [
    "/vehicle/type",
    "/booking/types",
    "/booking/status",
    "/container/type/list",
    "/container/status/list",
    "/user/profile/view",
    "/user/view",
    "/eid/qrcode",
    '/edi/view',
    "/eid/list/user",
    "/user/profile",
    "/subscription/org/view/active",
    "/profile/gatepass/type/entry-type",
    "/profile/gatepass/type/pass-type",
    "/users/list/all",
    "/profile/id-types",
    "/organization/view",
    "/org/users/list/search/drivers",
    "/rbac/profile/permission",
    "/profile/gatepass/type/list",
    "/profile/gatepass/type/create",
    "/profile/gatepass/type/view",
    "/profile/gatepass/type/update/status",
    "/profile/gatepass/type/delete",
    "/profile/gatepass/type/update",
    "/profile/types",
    "/rbac/profile/role",
    "/organization/orgnames",
    "/booking/post-query/ids"

]

const forceOrgPrefixPagesRoutes = [
    "/organization/view",
    "/organization/view/vehicles",
    "/organization/view/gatepass",
    "/organization/view/bookings",
    "/organization/view/containers",
    "/organization/view/users",
    "/organization/view/drivers",
    "/organization/view/gatepass/create",
    "/drivers/create",
    "/organization/driver/create",

    "/organization/view/vehicles/create",
    "/organization/view/vehicles/edit",
    "/organization/view/vehicles/view",

    "/organization/view/bookings/create",
    "/organization/view/bookings/edit",
    "/organization/view/bookings/view",

    "/organization/view/containers/create",
    "/organization/view/containers/edit",
    "/organization/view/containers/view",
    "/organization/user/create"
]

const apiPrefixes = ['org', 'assigned', 'all']

const modules = {
    DASHBOARD: 'dashboard',
    USERS: 'users',
    CONTAINERS: 'container',
    GATEPASS: 'gatepass',
    VEHICLE: 'vehicle',
    BOOKING : 'booking',
    DRIVERS : 'drivers',
}

const assignedModules = {
  PORT_EMPLOYEE: {...modules},
  BUSINESS: [modules.DASHBOARD, modules.USERS, modules.CONTAINERS, modules.GATEPASS, modules.VEHICLE, modules.BOOKING, modules.DRIVERS],
  INDIVIDUAL: [modules.GATEPASS, modules.VEHICLE, modules.BOOKING, modules.DRIVERS],
}; 

const profile_types = {
    PORT_EMPLOYEE: "Port Employee",
    BUSINESS: "Business",
    INDIVIDUAL: "Individual"
}

// const profile_types = {
//     PORT_EMPLOYEE: ["Admin", "Employee"],
//     BUSINESS: ["BusinessOwner", "BusinessDriver"],
//     INDIVIDUAL: ["Resident", "Driver"]
// }

export {permissions, assignedPermissions, assignedModules, modules, profile_types, apiPrefixes, exemptedAPIPrefixRoutes, forceOrgPrefixPagesRoutes}
